import { j as C } from "./AccesRecoveryIcon-CUPieIxT.js";
const e = () => /* @__PURE__ */ C.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ C.jsx(
    "path",
    {
      d: "M20.5682 14.3356C21.2583 15.0323 21.5968 15.8855 21.5408 16.7874C21.4848 17.6893 21.0368 18.5993 20.2534 19.4023C19.4701 20.2054 18.3867 20.8655 17.1401 21.2991C15.8935 21.7327 14.5397 21.9204 13.25 21.8384C11.9604 21.7563 10.7926 21.4083 9.89454 20.8383C8.99645 20.2683 8.40834 19.5019 8.20456 18.6361C8.00079 17.7702 8.19052 16.8438 8.74974 15.9739C9.30897 15.1041 10.2126 14.3298 11.3463 13.7492L12.1838 14.5945C11.3222 15.0359 10.6354 15.6243 10.2104 16.2854C9.7854 16.9465 9.64121 17.6506 9.79608 18.3086C9.95095 18.9667 10.3979 19.5491 11.0805 19.9823C11.763 20.4155 12.6505 20.68 13.6306 20.7423C14.6108 20.8047 15.6396 20.662 16.5871 20.3325C17.5345 20.003 18.3579 19.5013 18.9532 18.891C19.5486 18.2806 19.889 17.589 19.9316 16.9036C19.9742 16.2182 19.7169 15.5697 19.1924 15.0403L20.5682 14.3356Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      d: "M19.4308 15.3131C18.741 14.6162 18.4029 13.7629 18.4593 12.861C18.5157 11.9591 18.9641 11.0491 19.7478 10.2462C20.5314 9.44322 21.6151 8.78334 22.8619 8.34998C24.1086 7.91662 25.0813 7.64673 26.3709 7.72902C27.6605 7.81132 29.2091 8.2421 30.1068 8.81232C31.0046 9.38253 31.5924 10.1491 31.7958 11.015C31.9991 11.881 31.809 12.8074 31.2494 13.6772C30.6898 14.547 29.7859 15.321 28.6519 15.9015L27.8148 15.0559C28.6766 14.6147 29.3636 14.0265 29.7889 13.3654C30.2142 12.7044 30.3587 12.0003 30.2042 11.3422C30.0496 10.6841 29.6029 10.1015 28.9206 9.66812C28.2383 9.23476 27.351 8.97007 26.3709 8.90752C25.3908 8.84498 24.3619 8.98739 23.4144 9.31675C22.4669 9.6461 21.6433 10.1476 21.0477 10.7579C20.4521 11.3681 20.1113 12.0597 20.0685 12.7451C20.0256 13.4306 20.2825 14.0791 20.8068 14.6087L19.4308 15.3131Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.6193 10.0579L10.4088 21.0632L9.66551 19.7641L28.876 8.75875L29.6193 10.0579Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.3022 21.3205C35.3804 19.4111 36.8625 17.0449 36.8625 14.7857C36.8625 12.5266 35.3804 10.1603 32.3022 8.25092C29.2541 6.3602 24.9102 5.12143 20 5.12143C15.0898 5.12143 10.7459 6.3602 7.69784 8.25092C4.61964 10.1603 3.1375 12.5266 3.1375 14.7857C3.1375 17.0449 4.61964 19.4111 7.69784 21.3205C10.7459 23.2112 15.0898 24.45 20 24.45C24.9102 24.45 29.2541 23.2112 32.3022 21.3205ZM20 26.5714C30.4934 26.5714 39 21.2948 39 14.7857C39 8.27664 30.4934 3 20 3C9.50659 3 1 8.27664 1 14.7857C1 21.2948 9.50659 26.5714 20 26.5714Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36.625 24.2143C36.625 26.7447 34.1658 29.4964 31.2812 31.2857C31.0779 31.4118 30.8675 31.5325 30.6505 31.6477C29.4768 32.2711 28.1119 32.7377 26.6485 33.0713C24.5443 33.5508 22.2364 33.7553 20 33.7553C17.7636 33.7553 15.4557 33.5508 13.3515 33.0713C11.8881 32.7377 10.5232 32.2711 9.3495 31.6477C9.13252 31.5325 8.92208 31.4118 8.71875 31.2857C5.8342 29.4964 3.375 26.7447 3.375 24.2143L1 24.2143C1 24.9308 1.10519 25.6406 1.31025 26.3357C1.99978 28.673 3.81857 30.8444 6.56497 32.548C7.1404 32.905 7.74893 33.2367 8.38609 33.5419C9.75525 34.1979 11.2566 34.7319 12.8457 35.1326C15.0965 35.7 17.5233 36 20 36C22.4767 36 24.9035 35.7 27.1543 35.1326C28.7434 34.7319 30.2447 34.1979 31.6139 33.5419C32.2511 33.2367 32.8596 32.905 33.435 32.548C36.1814 30.8444 38.0002 28.673 38.6897 26.3357C38.8948 25.6406 39 24.9308 39 24.2143H36.625Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.375 17.1427V24.8035L1 24.2143V14.7857L3.375 17.1427ZM39 14.7857V24.2143L36.625 24.8035V17.1427L39 14.7857Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.0219 21.2679V30.1071H33.4781V21.2679H35.0219ZM6.16563 31.2857V22.4464H7.70938V31.2857H6.16563Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.2625 24.8036V34.2321H27.3625V24.8036H29.2625ZM11.925 34.8214V25.3929H13.825V34.8214H11.925Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.4062 34.8214V25.9821H21.7812V34.8214H19.4062Z",
      fill: "currentColor"
    }
  )
] });
export {
  e as B
};
